// client/src/components/ScheduledBooking.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Button, Form, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { scheduleBooking } from '../services/api';

const ScheduledBookingModal = ({ show, onHide, course, targetDate }) => {
  const [startTime, setStartTime] = useState('08:00');
  const [endTime, setEndTime] = useState('11:00');
  const [capacity, setCapacity] = useState(4);
  const [expireHours, setExpireHours] = useState(4);
  const [convertToStandby, setConvertToStandby] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const scheduleData = {
      courseId: course.id,
      targetDate,
      startTime,
      endTime,
      capacity: parseInt(capacity),
      expireHours: parseInt(expireHours),
      convertToStandby,
    };

    try {
      const result = await scheduleBooking(scheduleData);
      if (result.success) {
        alert('Your booking has been scheduled successfully! Check "My Bookings" for status updates.');
        onHide();
        navigate('/bookings'); // ✅ Redirect on success
      } else {
        setError(result.error || 'An unknown error occurred.');
      }
    } catch (err) {
      setError(err.error || 'Failed to submit request.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Schedule a Future Booking for {course?.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted">
          This tee time is not available yet. Set your preferences below and we’ll attempt to book it for you automatically when the booking window opens. If the window opens but nothing in your time range is available yet, you can optionally have us keep watching for a last-minute opening (standby) instead of giving up.
        </p>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Target Date</Form.Label>
                <Form.Control type="date" value={targetDate} readOnly disabled />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                  <Form.Label>Number of Players</Form.Label>
                  <Form.Select value={capacity} onChange={e => setCapacity(e.target.value)}>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                  </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
                <Form.Group>
                    <Form.Label>Earliest Time</Form.Label>
                    <Form.Control type="time" value={startTime} onChange={e => setStartTime(e.target.value)} />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>Latest Time</Form.Label>
                    <Form.Control type="time" value={endTime} onChange={e => setEndTime(e.target.value)} />
                </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3">
              <Form.Label>Stop Trying Before Tee Time</Form.Label>
              <Form.Select value={expireHours} onChange={e => setExpireHours(e.target.value)}>
                  <option value="1">1 hour</option>
                  <option value="2">2 hours</option>
                  <option value="4">4 hours (default)</option>
                  <option value="8">8 hours</option>
              </Form.Select>
              <Form.Text className="text-muted">
                This is the final cutoff for the whole search — including standby below, if you turn it on. It doesn't apply before the booking window opens.
              </Form.Text>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Check
                type="switch"
                id="standby-switch"
                label="Once the booking window opens, if nothing in my time range is available yet, keep watching for a last-minute opening (standby)?"
                checked={convertToStandby}
                onChange={e => setConvertToStandby(e.target.checked)}
            />
          </Form.Group>
          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={onHide} disabled={isLoading} className="me-2">
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={isLoading}>
              {isLoading ? <Spinner as="span" animation="border" size="sm" /> : 'Schedule Booking'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ScheduledBookingModal;